import { defineSlotRecipe } from '@chakra-ui/react';

export const scrollAreaRecipe = defineSlotRecipe({
  className: 'chakra-scroll-area',
  slots: ['root', 'viewport', 'content', 'scrollbar', 'thumb', 'corner'],
  base: {
    root: {
      display: 'flex',
      flexWrap: 'nowrap',
      gap: 0,
      flexDirection: 'row',
      '&[data-orientation=horizontal]': {
        flexDirection: 'column',
      },
    },
    content: {
      flex: 1,
      minWidth: '100% !important',
    },
    scrollbar: {
      position: 'relative !important',
      borderRadius: 0,
      margin: 0,
      colorPalette: undefined,
      backgroundColor: 'neutral.850',
      opacity: 1,
      '&:not([data-force-overflow])': {
        display: 'none',
      },
    },
    thumb: {
      backgroundColor: 'neutral.600',
    },
  },
  variants: {
    variant: {
      'border-900': {
        scrollbar: {
          _horizontal: {
            borderColor: 'neutral.900',
          },
          _vertical: {
            borderColor: 'neutral.900',
          },
        },
      },
    },
    size: {
      small: {
        scrollbar: {
          _vertical: {
            borderLeft: '1px solid',
            width: '5px',
          },

          _horizontal: {
            borderTop: '1px solid',
            height: '5px',
          },
        },
      },
      medium: {
        scrollbar: {
          _vertical: {
            borderLeft: '2px solid',
            width: '10px',
          },

          _horizontal: {
            borderTop: '2px solid',
            height: '10px',
          },
        },
      },
    },
  },
  defaultVariants: {
    variant: 'border-900',
    size: 'medium',
  },
});
